import React, { useState, useEffect } from 'react';
import './displayModal.css';
import DisplayContent from './displayContent';
import ToggleButton from '../../components/common/Switch/toggleButton';
import { parseRequestBody } from '../../genericFunctions/parseReqBody';
import { useNavigate } from 'react-router-dom';
import { formErrorHandling } from '../../genericFunctions/erroHandling';
import { fetchPAI_UsermanualData } from '../../api/firmwareApi';
import { TextToPemConverter } from '../../genericFunctions/textToPemConverter';
import { GenerateFileName } from '../../genericFunctions/generateFileName';
import { fetchDataFromFile_Text, fetchDataFromFile_Blob } from '../../genericFunctions/fetchSignerLabelFromFile_Text';
import { fetchCRLLabelFromPAI } from '../../api/revocationsApi';
import { fetchMacListfromDeviceViaPid } from '../../api/devicesApi';
import { NullUndefinedCheck } from '../../genericFunctions/nullUndefinedCheck';
import handle_toast from '../../genericFunctions/toast_Handler';


function DisplayModal({ toggleModal, data, source, editFormValue, onSave, page, onBulkDeviceUpload, fullDisableForm, productStatus, onPublish_Upload }) {
    const navigate = useNavigate(); 
    const [dataCopy, setDataCopy] = useState({}) 
    const [formattedData, setFormattedData] = useState({});
    const initialFormFields = source?.includes('edit') && editFormValue ? JSON.parse(JSON.stringify(editFormValue)) : {};
    const [formFields, setFormFields] = useState({ ...initialFormFields });
    const [formErrors, setFormErrors] = useState({});
    const [disableSaveClick, setDisableSaveClick] = useState(true);
    const [selectedToggle, setToggleValue] = useState(null)
    const [tableUpdate, setTableUpdate] = useState(source?.includes('edit') && page === 'teams' ? false: true)
    const dropDownOption = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')): {};
    const [dropDownData, setDropDownData] = useState(sessionStorage.getItem('dropDownData') ? sessionStorage.getItem('dropDownData') : {})

    useEffect(() => {            
        if(page == 'product'){            
            if(source?.includes('edit')){
                if(formFields['vid'] == '4190') formFields['vid_name'] = 'Schneider Electric'
                else if(formFields['vid'] == '5481') formFields['vid_name'] = 'Feller'
            }
        }  
        if(NullUndefinedCheck(dropDownData)) setDropDownData(sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {})
    }, [dropDownData])

    useEffect(() => {
        if(page === 'teams' && !tableUpdate) {
            if (Object.keys(dataCopy).length !== 0) {
                updateList();
                setTableUpdate(true)
            }
        }
    }, [tableUpdate, dataCopy])

    useEffect(() => {
        if (Object.keys(dataCopy).length == 0) setDataCopy(JSON.parse(JSON.stringify(data)))
        if (Object.keys(dataCopy).length !== 0) {
            formatData();
            if(selectedToggle == null && source?.includes('edit') && page == 'revocation') {
                setToggleValue(formFields['docType']) 
                handleToggle(formFields['docType']);
            }
            if(selectedToggle == null && source?.includes('edit') && page == 'device') {
                setToggleValue(dataCopy.toggleFields[0]) 
                handleToggle(dataCopy.toggleFields[0]);
            }
            if(selectedToggle == null && source?.includes('create') && dataCopy.toggleFlag) {
                setToggleValue(dataCopy.toggleFields[0]) 
                handleToggle(dataCopy.toggleFields[0]);
            }
            if(Object.keys(formattedData).length !== 0) toggleModal();
        }
    }, [dataCopy]);
    
    const handleInputChange = (value, name) => {
        if(name?.includes('revokSelect')){
            if(value == 'PAI'){
                const newData = dataCopy;
                newData.childrenItems.filter((obj) => {
                    if(obj.key !== 'matterProductId') return obj;
                })
                setFormattedData(null)
                setDataCopy(newData);
            }
        }
        if (page == 'product') {
            if(name == 'vid_name'){
                const vid_val = dropDownOption[value][0].name;
                formFields['vid'] = vid_val;
            }
            if(name == 'team'){
                dropDownOption['Teams'].map((obj) => {
                    if(obj.name == value) {
                        setFormFields((preFields) => ({
                            ...preFields,
                            ['teamId']: obj.id
                        }))
                    }
                })
            }
            if (name == 'category') {
                dataCopy.childrenItems.map((obj) => {
                    if (obj.key === 'device') {
                        formFields[obj.key] = null
                        obj.optionList = value;
                    }
                });
                formatData();
            }
            if (name == 'device') {
                setFormFields((preFields) => ({
                    ...preFields,
                    ['matterDeviceTypeId']: parseInt(value.split(', ')[1], 16)
                }));
            }            
            if(name == 'commissioningFlow' && value == 'Custom'){
                dataCopy.childrenItems.map((obj) => {
                    if(obj.key == 'commissioningFlowURL') obj.required = true;
                })
                formatData();
            }           
            if(name == 'commissioningFlow' && value !== 'Custom'){
                dataCopy.childrenItems.map((obj) => {
                    if(obj.key == 'commissioningFlowURL') obj.required = false;
                })
                formatData();
            }
        }
        if(page == 'Firmware' || page.includes('User Manual') || page == 'PAI' || page == 'certificate'){
            if(name?.includes('fileName')){
                setFormFields((preFields) => ({
                    ...preFields,
                    ['file']: value[0].file,
                    ['fileName']: value[0].file.name
                }));
            }
        }
        if(page === 'device') {
            if(selectedToggle == 'Bulk') {
                setFormFields({})
                setFormFields((preFields) => ({
                    ...preFields,
                    ['file']: value[0].file,
                    ['fileName']: value[0].file.name
                }));
            } else {
                if (name === 'productId') {
                    dropDownOption['ProductList'].map(obj => {
                        if (value === obj.name) {
                            formFields.category = obj.category;
                            formFields.productName = obj.label;
                        }
                    });
                }
            }
        }
        if(page == 'certificate'){
            if(name == 'productId') {            
                setFormFields((prevFields) => {
                    const formFields = { ...prevFields };
                    if(formFields['macAddress']) delete formFields['macAddress'];
                    if(formFields['pai']) delete formFields['pai'];
                    return formFields;
                });
                fetchMACList(value);
                fetchPAIList(value);
            }
            if(name == 'dacCertificate') {
                if(value && value !== ''){
                    const fileName =  GenerateFileName();
                    setTimeout(() => {
                        setFormFields((preFields) =>  ({
                            ...preFields,
                            ['fileName']: fileName,
                            ['file']: TextToPemConverter(value, fileName),
                        }));
                    }, 1000)
                }
                else{
                    delete formFields['file']
                    delete formFields['fileName']
                }
            }
        }
        if(page == 'revocation') {
            setFormFields((preFields) => ({
                ...preFields,
                ['docType']: selectedToggle,
            }));        
            if(name?.includes('paiCert')){   
                const matchingObject = JSON.parse(dropDownData)['CRLSignerCertificate'].find(
                    (item) => item.name === value
                );            
                if (matchingObject) {
                    const formattedDoc = formattedPemCert(matchingObject.crlSignerCertificate, 'clean')
                    fetchDataFromFile_Text(formattedDoc).then(response => {
                        setFormFields((preFields) => ({
                            ...preFields,
                            ['crlSignerLabel']: response.skiValue,
                            ['crlSignerCertificate']: formattedPemCert(matchingObject.crlSignerCertificate, 'original')
                        }));
                    })
                }
            }
            if(name == 'productId') fetchPAIList(value);
            if(name == 'pai') fetchCRLLabelFromPAIInfo(value);
        }
        if(!name?.includes('fileName') && !name?.includes('Table')){
            setFormFields((prevFields) => ({
                ...prevFields,
                [name]: value,
            }));
        }
        if(page === 'teams') {
            if(name?.includes('List')) {
                const subKey = name.split('List')[0];
                const listData = formFields[name];
                formFields[name].filter((user, index) => {
                    if(user.name == value.name) listData.splice(index, 1);
                })
                setFormFields((prevFields) => ({
                    ...prevFields,
                    [name]: listData,
                }));
                formFields[subKey].splice(formFields[subKey].indexOf(value.name), 1);
                setTableUpdate(false)
            }
            else if(name === 'productOwner' || name === 'member') {
                const newList = dropDownOption['Users'].filter((user) => value.indexOf(user.name) > -1)
                setFormFields((prevFields) => ({
                    ...prevFields,
                    [`${name}List`]: newList,
                }));
                setTableUpdate(false)
            }

        }
        handleValidateForm();
        handleErrors(value, name);
    };

    const fetchCRLLabelFromPAIInfo = async (pai) => {
        try{
            const resp = await fetchCRLLabelFromPAI({'pai': pai});
            fetchDataFromFile_Blob (resp?.data).then(response => {
                setFormFields((preFields) => ({
                    ...preFields,
                    ['crlSignerLabel']: response.skiValue,
                    ['crlSignerCertificate']: formattedPemCert(response.context, 'clean')
                }));
            })
        }
        catch(error){
            handle_toast(error)
        }
    }

    const formattedPemCert = (context, require) => {        
        const b64 = context.replace(/(-----(BEGIN|END) CERTIFICATE-----|\s)/g, '');
        const originalCert = b64.replace(/(\r\n|\n\r|\\r\\n|\\n\\r|\\r|\\n)/g, '\n');
        const cleanCert = b64.replace(/(\r\n|\n\r|\\r\\n|\\n\\r|\\r|\\n)/g, '')
        const pemCert = `-----BEGIN CERTIFICATE-----\n${cleanCert}\n-----END CERTIFICATE-----\n`;
        const completeCert = `-----BEGIN CERTIFICATE-----\n${originalCert}\n-----END CERTIFICATE-----\n`;
        if(require == 'clean'){
            return pemCert;
        }
        else if(require == 'original'){
            return completeCert;
        }
    }

    const fetchPAIList = async (productId) => {
        try{
            const resp = await fetchPAI_UsermanualData({'productId': productId, 'docType': 'PAI'});
            const paiFormat = [];
            if(resp?.data?.data?.length > 0) {                
                setFormErrors((prevFields) => {
                    const updatedErrors = { ...prevFields };
                    delete updatedErrors['pai'];
                    return updatedErrors;
                });
                resp?.data?.data?.map((obj) => {
                    paiFormat.push({name: obj.fileLabel, label: obj.fileLabel, productId: obj.productId, checked: false})
                })
            }
            else setFormErrors((prevFields) => ({...prevFields, ['pai']: `No PAI found for Selected PID`})); 
            dropDownOption.PAIList = paiFormat ;
            sessionStorage.setItem('dropDownData', JSON.stringify(dropDownOption));
            setDropDownData(sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {})
        }
        catch(error){
            handle_toast(error)
        }
    }

    const fetchMACList = async (productId) => {
        try{
            const resp = await fetchMacListfromDeviceViaPid({'productId': productId});
            const macList = [];
            if(resp?.data?.data?.length > 0) {                
                setFormErrors((prevFields) => {
                    const updatedErrors = { ...prevFields };
                    delete updatedErrors['macAddress'];
                    return updatedErrors;
                });
                resp?.data?.data?.map((obj) => {
                    macList.push({name: obj.macAddress, label: obj.macAddress, productId: obj.productId, checked: false})
                })
            }
            else setFormErrors((prevFields) => ({...prevFields,['macAddress']: `No MAC Address found for Selected PID`})); 
            dropDownOption.MACList = macList ;
            sessionStorage.setItem('dropDownData', JSON.stringify(dropDownOption));
            setDropDownData(sessionStorage.getItem('dropDownData'))
        }
        catch(error){
            handle_toast(error)
        }
    }

    const updateList = () => {
        const updatedPOList = dropDownOption['Users'].filter((item) =>  {
            if(formFields && formFields['member']?.indexOf(item.name) == -1 ) return item;
        })

        const updatedMemberList = dropDownOption['Users'].filter((item) =>  {
            if(formFields && formFields['productOwner']?.indexOf(item.name) == -1 ) return item;
        })
                     
        dataCopy.childrenItems.map((obj) => {
            if(obj.key == 'member' && updatedMemberList) obj.optionList = updatedMemberList;
            if(obj.key == 'productOwner' && updatedPOList) obj.optionList = updatedPOList;
            if(obj.key == 'productOwner' && updatedPOList.length == 0 && formFields['member']?.length !== dropDownOption['Users'].length) obj.optionList = dropDownOption['Users']
            if(obj.key == 'member' && updatedMemberList.length == 0 && formFields['productOwner']?.length !== dropDownOption['Users'].length) obj.optionList = dropDownOption['Users']
        })
        formatData();
    }

    const handleToggle = (data) => {
        setToggleValue(data);
        if(page !== 'device' && !source.includes('edit')) setFormFields({})
        setDisableSaveClick(true);
        dataCopy.childrenItems = null;
        dataCopy.childrenItems = dataCopy.toggleData[data];
        setDataCopy(dataCopy ? dataCopy : {})
        // setDataCopy((prevData) => {
        //     return { ...prevData, childrenItems: dataCopy.childrenItems}
        // })
        setFormattedData({});
        formatData();
    };

    const formatData = () => {
        if(source == 'upload'){
            if(editFormValue['status']?.includes('Publish')){
                var tempArr = dataCopy.childrenItems.filter((obj) => {
                    if(obj.key !== 'publish') return obj;
                })
                dataCopy.childrenItems = tempArr;
            }
        }
        if(dataCopy.toggleFlag && dataCopy.childrenItems == null) dataCopy.childrenItems = dataCopy.toggleData[selectedToggle]; 
        setDataCopy(dataCopy ? dataCopy : {})
        // setDataCopy((prevData) => {
        //     return { ...prevData, childrenItems: dataCopy.childrenItems}
        // })
        const formatdata = Array.isArray(dataCopy.childrenItems)
            ? dataCopy.childrenItems.reduce((acc, item) => {
                if (!acc[item.section]) {
                    acc[item.section] = {
                        title: data.sectionTitle ? data.sectionTitle.find((title) => title.section === item.section)
                            ?.name : '',
                        fields: [],
                    };
                }
                acc[item.section].fields.push(item);
                return acc;
            }, {})
            : {};
        setFormattedData(formatdata);    
        const updatedFormError = formErrorHandling(formFields, formErrors, page, source)
        setFormErrors({...updatedFormError})
        handleValidateForm();
    }

    useEffect(() => {
        for(let key in formFields){
            if(key.includes('FileName')) {
                const subKey = key.split('FileName')[0]
                formFields[`${subKey}FileUpload`] = formFields[key];
            }
        }
        const updatedFormError = formErrorHandling(formFields, formErrors, page, source)
        setFormErrors({...updatedFormError})
        handleValidateForm();
    }, [formFields]);

    const handleErrors = (value, key) => {
        const fieldToCheck = dataCopy.childrenItems.find(field => field.key === key);
        if (fieldToCheck) {
            const { required, key } = fieldToCheck;
            if (required) {
                if (value == '') setFormErrors((prevFields) => ({...prevFields,[key]: `Mandatory Field`}));
                if(value !== '' && formErrors[key] == `Mandatory Field`) delete formErrors[key];
            }
        }
    };

    const handleValidateForm = () => {
        let errorCount = 0;
        dataCopy?.childrenItems?.map((field) => {
            const { required, key } = field;
            if(required && !Array.isArray(formFields[key]) && (formFields[key] === undefined || formFields[key]?.toString().trim() === '' || formErrors[key])){
                errorCount += 1;
            }
            if(required && Array.isArray(formFields[key]) && formFields[key].length == 0){
                errorCount += 1;
            }
        });
        let disableForm = false;
        if(Object.keys(formErrors).length == 0 && Object.keys(formFields).length !== 0) disableForm = false
        else if(page == 'certificate' && Object.keys(formErrors).length > 0) disableForm = false
        else disableForm = true;
        let formIsValid = errorCount === 0 && !disableForm? true : false;
        if(dataCopy && dataCopy.childrenItems) setDisableSaveClick(!formIsValid);
        return formIsValid;
    };

    const handleSaveClick = (e) => {
        const formVal = parseRequestBody(formFields)
        e.preventDefault();
        if (handleValidateForm()) {
            toggleModal();
            if(selectedToggle == 'Bulk') {
                onBulkDeviceUpload(formVal)
            } 
            else if(source?.includes('upload') && !Object.keys(formFields).includes('publish')) {
                navigate(`/productInformation/${editFormValue.matterProductId}?vid=${editFormValue.vid}`, { state : formVal})
            }
            else if(source?.includes('upload') && Object.keys(formFields).includes('publish')){
                onPublish_Upload(editFormValue)
            }
            // if(source?.includes('upload') && Object.keys(formFields).includes('Upload')){
            //     onPublish_Upload(formFields)
            // }
            else {
                if(page == 'Firmware' || page == 'product') {
                    // const hexPattern = /^[0-9a-fA-F]*[a-fA-F]+[0-9a-fA-F]*$/;
                    const hexPattern = /^(0[xX][0-9a-fA-F]+|[0-9]+)$/;
                    const hexValArr = ['matterProductId', 'commissioningHint1', 'commissioningHint2', 'availableMaxVer', 'availableMinVer', 'cdVersion', 'majorVersion'];
                    for(let key in formVal){          
                        if (hexValArr.indexOf(key) > -1) {
                            if(hexPattern.test(formFields[key]) && !/^[0-9]*$/.test(formFields[key])) formVal[key]= parseInt(formFields[key], 16)
                        }
                    } 
                }
                onSave(formVal);
            }
        }
    };

    return (
        <div className='modal-overlay'>
            <div className={dataCopy.childrenItems?.length > 8 ? 'modal-container modalGrid' : dataCopy.childrenItems?.length < 8 && dataCopy.childrenItems?.length > 2 ? 'modal-container smallerGrid' : 'modal-container x-smallerGrid'} style={{ 'width': dataCopy.childrenItems?.length > 6 ? '' : 'min-content' }}>
                <div className='modal-header'>
                    <span>{source?.includes('create') ? data.createTitle : source?.includes('edit') ? data.editTitle : data.viewTitle}</span>
                    <se-icon size='small' option='button' onClick={toggleModal}>action_close</se-icon>
                </div>
                <form onSubmit={handleSaveClick}>
                    <div className='modal-body'>
                        {Object.keys(dataCopy).length !== 0 && dataCopy.toggleFlag && selectedToggle!==null && <div className='secondSection'><ToggleButton left={dataCopy.toggleFields[0]} right={dataCopy.toggleFields[1]} defaultSelected={selectedToggle} selectedToggleChange={handleToggle} source={source} disabled={source?.includes('edit') && dataCopy.disableOnEdit}
                                        activatedDeactivatedSelection={dataCopy.activatedDeactivatedSelection}/></div>}
                        {
                            Object.keys(formattedData).length > 0 && Object.entries(formattedData).map(([key, value]) => (
                                <div key={`section` + key} className={!dataCopy.imageModal ? 'secondSection' : 'firstSection'}>
                                    <p style={{ paddingLeft: '10px', paddingTop: '10px', fontSize: '14px', fontWeight: 'bold' }}>{value.title}</p>
                                    {value && <DisplayContent formErrors={formErrors} formFields={formFields} source={'modal' + source} contentData={value.fields} handleInputChange={handleInputChange} fullDisableForm={fullDisableForm} page={page} productStatus={productStatus}/>}
                                </div>
                            ))
                        }
                    </div>
                    <div className='modal-footer'>
                        <se-button option="outline" onClick={toggleModal}>Cancel</se-button>
                        <se-button option="flat" color="primary" type='submit' disabled={disableSaveClick}>Save</se-button>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default DisplayModal;